import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { CTAButton } from './CTAButton';
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-12 sm:px-6 sm:py-16" data-id="element-235" data-mp="3fznvbprkvj3h">
      <div className="mx-auto max-w-3xl" data-id="element-236" data-mp="3fxuni758astw">
        <h2 className="text-center font-serif text-[27px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-237" data-mp="3b0uilzk47w4d">
          Lo que ya están diciendo otros médicos
        </h2>
        <div className="mt-3 flex flex-col items-center gap-1" data-id="element-238" data-mp="36wmofmuw1nyr">
          <div className="flex gap-0.5" aria-hidden="true" data-id="element-239" data-mp="31z3cwupkrpai">
            {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-240" data-mp="2x1bj1v5ddt3o" />)}
          </div>
          <p className="text-[13px] font-semibold text-navy-700/80" data-id="element-241" data-mp="2s3jfu4z9ykk6">
            4.9/5 basado en más de 1.200 médicos
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-242" data-mp="q9tzzmpyv2kk">
          {testimonials.map(item => <figure key={item.name} className="flex flex-col rounded-2xl border border-navy-100 bg-white p-5 shadow-card" data-id="element-243" data-mp="h5ezbmd4bx17">
              <div className="flex gap-0.5" aria-hidden="true" data-id="element-244" data-mp="m2omevd1bwlv">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" data-id="element-245" data-mp="c6ve5o6cmp9w" />)}
              </div>
              <blockquote className="mt-3 flex-1 text-[14.5px] leading-relaxed text-navy-900/85" data-id="element-246" data-mp="zyscqdksfkt2">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-navy-100 pt-4" data-id="element-247" data-mp="q5v1msi4ky4h">
                <img src={item.avatar} alt={`Retrato de ${item.name}, ${item.role}`} className="h-12 w-12 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-248" data-mp="v4ep4xcdahyy" />
                <div className="min-w-0" data-id="element-249" data-mp="1nnv0m360m9w0">
                  <p className="text-[14px] font-bold text-navy-900" data-id="element-250" data-mp="1xgxxl5nthzkb">
                    {item.name}
                  </p>
                  <p className="text-[12.5px] leading-snug text-navy-700/75" data-id="element-251" data-mp="1sjfmb8mbv895">
                    {item.role} — {item.country}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-252" data-mp="1eiv34bci3af4">
          <CTAButton label="Sumarme a los +1.200 médicos" note="Acceso inmediato tras el pago" data-id="element-253" data-mp="1ekpplu3f7alb" />
        </div>
      </div>
    </section>;
}